import React from "react";
import DataGrid, {
  Column,
  Paging,
  FilterRow,
  Sorting,
} from "devextreme-react/data-grid";
import PyramidCard from "./PyramidCard";

const FeedbackDatagrid = ({ bugsInProgress }) => {
  return (
    <PyramidCard title="Bugs in Progress" className="mt-4">
      <div>
        <p className="mt-n2 mb-1">
          Here is the list of bugs that have been reported and on which our team
          is currently working.
        </p>
        <DataGrid
          dataSource={bugsInProgress}
          showBorders={true}
          rowAlternationEnabled={true}
          height="auto"
          className="w-100"
          columnAutoWidth={true}
        >
          <Paging defaultPageSize={8} />
          <FilterRow visible={true} />
          <Sorting mode="multiple" />

          <Column dataField="title" caption="Title" />
          <Column
            dataField="status"
            caption="Status"
            alignment="center"
            cellRender={({ data }) => (
              <span
                className={`badge badge-subtle-${
                  data.status === "In Progress" ? "warning" : "success"
                } d-flex justify-content-center`}
              >
                {data.status}
              </span>
            )}
          />
          <Column
            dataField="priority"
            caption="Priority"
            alignment="center"
            cellRender={({ data }) => (
              <span
                className={`badge badge-subtle-${
                  data.priority === "High"
                    ? "danger"
                    : data.priority === "Medium"
                    ? "warning"
                    : "info"
                } text-${
                  data.priority === "High"
                    ? "danger"
                    : data.priority === "Medium"
                    ? "warning"
                    : "info"
                } d-flex justify-content-center`}
              >
                {data.priority}
              </span>
            )}
          />
          <Column
            dataField="dateReported"
            caption="Date of reporting"
            dataType="date"
            alignment="center"
          />
          <Column dataField="description" caption="Description" />
        </DataGrid>
      </div>
    </PyramidCard>
  );
};

export default FeedbackDatagrid;
